// extracted by mini-css-extract-plugin
export default {"dictaphone":"Dictaphone_dictaphone__XCi1A"};